// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : created action
// MODIFIED DATE : 06-10-2025

import ENACHReportActionTypes from './MandateReport.types';

/** ***************** GET MANDATE REPORT START *********************** */
export const fetchENACHMandateReportStart = (getData: any) => ({
	type: ENACHReportActionTypes.FETCH_ENACH_MANDATE_REPORT_START,
	payload: getData,
});

export const fetchENACHMandateReportSuccess = (successData: any) => ({
	type: ENACHReportActionTypes.FETCH_ENACH_MANDATE_REPORT_SUCCESS,
	payload: successData,
});

export const fetchENACHMandateReportFailure = (failureData: any) => ({
	type: ENACHReportActionTypes.FETCH_ENACH_MANDATE_REPORT_FAILURE,
	payload: failureData,
});

export const fetchENACHMandateReportResponseReset = () => ({
	type: ENACHReportActionTypes.FETCH_ENACH_MANDATE_REPORT_RESPONSE_RESET,
});

export const fetchENACHMandateReportResponseChanged = () => ({
	type: ENACHReportActionTypes.FETCH_ENACH_MANDATE_REPORT_RESPONSE_CHANGED,
});

/** ***************** GET MANDATE REPORT END *********************** */
